export default __webpack_public_path__ + "static/media/vpConsequental.ee773bc0.svg";